var Expander = {

	selector: '[data-expander-open]',
	content: '[data-expander-content]',
	btnClose: '[data-expander-close]',

	init: function () {
		if (!$(this.selector).length) return;
		this.setDefaultState();
		this.bindClickEvent();
	},

	setDefaultState: function () {
		$(Expander.selector).attr('aria-expanded', 'false');
		$(Expander.content).attr('aria-hidden', 'true');
	},

	bindClickEvent: function () {

		$(Expander.selector).on('click', function (e) {

			// prevent default click behavior
			e.preventDefault();
			// stopPropagation to prevent the button click from bubbling up the DOM
			e.stopPropagation();

			// get attribute from button clicked
			var $thisSelector = $(this);
			var thisSelectorAttr = $thisSelector.attr('data-expander-open');

			Expander.unbindClickEvent($thisSelector);
			Expander.findMatchContent($thisSelector, thisSelectorAttr);

		});

	},

	findMatchContent: function ($thisSelector, thisSelectorAttr) {

		// get content that matched the attribute in the clicked button
		var matchedContentAttr = '[data-expander-content="' + thisSelectorAttr + '"]';
		var $matchedContentEl = $(matchedContentAttr);

		Expander.bindClickClose($thisSelector, $matchedContentEl);
		Expander.setAriaAttr($thisSelector, $matchedContentEl);
		Expander.setFocus($matchedContentEl);

	},

	bindClickClose: function ($thisSelector, $matchedContentEl) {

		var $thisBtClose = $matchedContentEl.find(Expander.btnClose);

		$thisBtClose.on('click', function (e) {

			var $thisCloseSelector = $(this);

			// prevent default click behavior
			e.preventDefault();
			// stopPropagation to prevent the button click from bubbling up the DOM
			e.stopPropagation();

			Expander.unbindClickEvent($thisCloseSelector);
			$(Expander.selector).off("click");
			$(Expander.content).removeAttr('tabindex');
			Expander.bindClickEvent();
			Expander.setAriaAttr($thisSelector, $matchedContentEl);
			// set focus back to the first opening element
			setTimeout(function () {
				$thisSelector.trigger('focus');
			}, 10);


		});
	},

	unbindClickEvent: function ($thisSelector) {
		$thisSelector.off("click");
	},

	setAriaAttr: function ($thisSelector, $matchedContentEl) {

		// check state and set the opposite attr
		var stateLink = $thisSelector.attr('aria-expanded') === 'false' ? true : false;
		var stateContent = $matchedContentEl.attr('aria-hidden') === 'true' ? false : true;

		// set button state
		$thisSelector.attr('aria-expanded', stateLink);
		// set content state
		$matchedContentEl.attr('aria-hidden', stateContent);

	},

	setFocus: function ($matchedContentEl) {

		// remove the focus
		$(Expander.content).removeAttr('tabindex');


		// set focus
		setTimeout(function () {
			$matchedContentEl.attr('tabindex', '-1');
			$matchedContentEl.trigger('focus');
		}, 10);

	}

};

$(document).ready(function () {
	Expander.init();
});